export default __webpack_public_path__ + "static/media/Photosnap - Portfolio.4fb4688f.png";